import bus from '@/utils/eventBus'
import { isMobile } from 'mobile-device-detect'

export default {
  data: function () {
    return {
      actions: false,
      isMobiled: false,
      isShowing: false,
      showModal: false
    }
  },
  props: {
    occurrence: {
      type: Object,
      require: true
    }
  },
  mounted: function () {
    if (isMobile) {
      this.isMobiled = true
    }
  },
  methods: {
    doShowMessage () {
      bus.$emit('show-message-occurrence', {show: true, occurrence: this.occurrence.id})
    },
    doShow () {
      this.isShowing = true
    },
    doHide () {
      this.isShowing = false
    },
    getImages () {
      bus.$emit('to-show', {show: true})
    },
    viewActions (status) {
      if (status) {
        this.actions = false
      } else {
        this.actions = true
      }
    },
    getTenantUnits (unit) {
      const params = {
        unit_id: unit.unit_id,
        tower_id: unit.tower_id
      }
      this.$http.post('/v1/dweller/unit/tenant/search', params)
        .then(({data}) => {
          return data
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/book-occurrence/index/components/resources/index.js